export default {
  list: [],
  dictList: {},
  totalItems: 0,
  loading: false
}
